import { render } from "./PrioridadeListagem.vue?vue&type=template&id=12d31837&ts=true"
import script from "./PrioridadeListagem.vue?vue&type=script&lang=ts"
export * from "./PrioridadeListagem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__